import React, { useState } from 'react';
import Icon from '../atom/Icon';
import './SearchBar.css';

const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && searchTerm.trim() !== '') {
      onSearch(searchTerm.trim()); // 🔁 Übergibt an App
    }
  };

  return (
    <div className="search-bar">
      <Icon name="locationMarker" className="search-icon" />
      <input
        type="text"
        value={searchTerm}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="search-input"
        placeholder={!isFocused && searchTerm === '' ? 'Location' : ''}
      />
    </div>
  );
};

export default SearchBar;
